module.exports = __webpack_public_path__ + "media/images/main_filmapp-ed484a4c.jpg";